import {CommentIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {useReviewers} from '../../data/use-reviewers'
import {CompletedReviewRow} from './shared/CompletedReviewRow'
import {buildReviewHeaderContent} from './shared/build-review-header-content'

export function CommentReview() {
  const {data: reviewers} = useReviewers()

  const commentReviews = reviewers.completedReviews?.filter(review => review.state === 'commented') ?? []

  if (commentReviews.length === 0) {
    return null
  }

  const {title, description} = buildReviewHeaderContent(commentReviews, 'commented')

  return (
    <ForYouItem icon={CommentIcon} title={title} itemName="comment-review" variant="default" description={description}>
      {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
      <ul className="list-none p-0" role="list">
        {commentReviews.map(review => (
          <CompletedReviewRow key={review.id} review={review} />
        ))}
      </ul>
    </ForYouItem>
  )
}
